<template>
  <layout>
    <div class="w-full flex flex-col my-8">
      <div class="unauth-form-header mb-2 semi-bold-font">Welcome to Pathao Admiral</div>
      <div class="unauth-form-desc">Login to your account by filling the form below</div>
    </div>
    <pt-form class="pb-8">
      <pt-form-group
        label="Email"
        label-for="username"
      >
        <pt-form-input
          id="username"
          v-model="username"
          type="text"
          placeholder="Enter your Email/Phone Number here"
        />
      </pt-form-group>
      <pt-form-group
        label="Password"
        label-for="password"
      >
        <pt-form-input
          id="password"
          v-model="password"
          type="password"
          placeholder="Enter your password here"
        />
      </pt-form-group>
      <router-link
        to="/reset-password"
        class="mb-4 no-underline text-primary font-bold hover:text-primary-dark space-letters"
      >Forgot your password?</router-link>
      <div class="flex lg:flex-row sm:flex-col justify-start">
        <div class="sm:w-full lg:w-1/3">
          <pt-button
            :disabled="tryingToLogIn || disableLoginBtn"
            variant="primary"
            class="sm:w-full lg:w-32"
            @action="tryToLogIn"
          >
            Sign In
            <pt-loader
              v-show="tryingToLogIn"
              icon-class="fa-spinner" />
          </pt-button>
        </div>
        <div class="flex justify-center items-center sm:mt-2 lg:mt-0 sm:w-full lg:w-2/3">
          <router-link
            class="text-grey-dark font-bold no-underline hover:text-grey-darker space-letters"
            to="/signup"
          >New partner? Sign Up</router-link>
        </div>
      </div>
    </pt-form>
  </layout>
</template>

<script>
import indexOf from 'lodash/indexOf';
import { mapGetters } from 'vuex';
import { PtForm, PtFormGroup, PtFormInput } from '@pathao/ui-components/esm/FormComponents';
import { PtButton } from '@pathao/ui-components/esm/Button';
import { PtLoader } from '@pathao/ui-components/esm/Loader';
import Layout from '@layouts/unauth';
import ApiProgress from '@plugins/ApiProgress';
import { authMethods } from '@state/helpers';
import appConfig from '@src/app.config';
import Config from '@src/config';

export default {
  page: {
    title: 'Log in',
    meta: [{
      name: 'description',
      content: `Log in to ${appConfig.title}`,
    }],
  },
  components: { Layout, PtForm, PtFormGroup, PtFormInput, PtButton, PtLoader },
  mixins: [ApiProgress],
  data() {
    return {
      username: null,
      password: null,
      tryingToLogIn: false,
    };
  },
  computed: {
    ...mapGetters({
      userRoles: 'auth/roles',
    }),
    disableLoginBtn() {
      return !this.username || !this.password;
    },
  },
  methods: {
    ...authMethods,
    tryToLogIn() {
      this.tryingToLogIn = true;

      this.logIn({
        username: this.username,
        password: this.password,
      }).then(() => {
        this.tryingToLogIn = false;
        let redirectPath = '404';

        if (indexOf(this.userRoles, Config.USER_ROLES.PARTNER) > -1) {
          redirectPath = 'captain-management-drivers';
        } else if (indexOf(this.userRoles, Config.USER_ROLES.SUPER_ADMIN) > -1) {
          redirectPath = 'activity-log-list';
        } else if (indexOf(this.userRoles, Config.USER_ROLES.ADMIRAL_ADMIN) > -1) {
          redirectPath = 'partner-list';
        }

        this.$router.push({ name: redirectPath });
      }).catch(error => {
        const hasErrMsg = error.response && error.response.data && error.response.data.message;
        const errorMsg = hasErrMsg ? error.response.data.message : 'User credentials not correct';

        this.$notification.error(errorMsg);
        this.tryingToLogIn = false;
      });
    },
  },
};
</script>
